import { render, staticRenderFns } from "./GofixSettingContainer.vue?vue&type=template&id=ff666d60&"
import script from "./GofixSettingContainer.vue?vue&type=script&lang=js&"
export * from "./GofixSettingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports